module.exports = __webpack_public_path__ + "media/assets/images/ActivationPage/simple_organization-e47f97897ceb52220d4b98ebb89476d3.png";